import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=2ef9b672&scoped=true"
import script from "./NoticeBar.vue?vue&type=script&lang=js"
export * from "./NoticeBar.vue?vue&type=script&lang=js"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=2ef9b672&prod&lang=scss&scoped=true"
import style1 from "./NoticeBar.vue?vue&type=style&index=1&id=2ef9b672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9b672",
  null
  
)

export default component.exports